import { Spinner } from "@maxhub/max-ui"

export const SpinnerExample = {
    title: 'Spinner',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'appearance',
            label: 'appearance',
            type: 'select',
            tsType: ['primary', 'themed', 'negative', 'neutral-themed', 'contrast-static', 'primary-static', 'contrast'],
            default: 'primary',
            options: [
                { value: "primary", label: "primary" },
                { value: "themed", label: "themed" },
                { value: "negative", label: "negative" },
                { value: "neutral-themed", label: "neutral-themed" },
                { value: "contrast-static", label: "contrast-static" },
                { value: "primary-static", label: "primary-static" },
                { value: "contrast", label: "contrast" },
            ],
        },
        {
            name: 'size',
            label: 'size',
            type: 'text',
            tsType: 'number',
            default: 20,
        },
    ],

    Preview({ props }){
        const size = Number(props.size) || 20

        return <Spinner appearance={props.appearance} size={size}/>
    },

    getCode(){
        return `<Spinner appearance="primary" size={20} />`
    }

}